/* https://stackoverflow.com/a/25490531/957731 */
export const getCookieValue = (name) => document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`)?.pop() || "";

let isRadigver: boolean;

export const setIsRadgiver = (radgiver: boolean) => {
	isRadigver = radgiver;
};

export const trackingEnabled = () => {
	const cookieValue = getCookieValue("sb1-optin");
	return !isRadigver && (cookieValue === "" || cookieValue.includes("S"));
};
